import { html, unsafeCSS } from 'lit'
import { property } from 'lit/decorators.js'

import { DdsElement } from '@/internal/dds-hu-element'

import styles from './option-group.scss?inline'

/**
 * `dap-ds-option-group`
 * @summary An option group is a container for grouping related option items.
 * Used with dap-ds-select to create grouped options that render as native optgroup elements.
 * @element dap-ds-option-group
 * @title - Option group
 *
 * @property {string} label - The label of the option group (displayed in native optgroup).
 * @property {boolean} disabled - Whether all options in the group are disabled.
 *
 * @slot - The option items in this group.
 *
 * @csspart base - The main option group container.
 * @csspart label - The label of the option group.
 */
export default class DapDSOptionGroup extends DdsElement {
  static tagName = 'dap-ds-option-group'

  /** The label of the option group */
  @property() label?: string

  /** Whether all options in the group are disabled */
  @property({ type: Boolean, reflect: true }) disabled?: boolean

  static readonly styles = unsafeCSS(styles)

  render() {
    return html`
      <div part="base" class="option-group">
        ${this.label
          ? html`<div part="label" class="option-group__label">
              ${this.label}
            </div>`
          : ''}
        <div class="option-group__items">
          <slot></slot>
        </div>
      </div>
    `
  }
}
